export const FETCH_TARIFF_BY_BUILDING = 'FETCH_TARIFF_BY_BUILDING'
export const CREATE_TARIFF_BY_BUILDING = 'CREATE_TARIFF_BY_BUILDING'
export const UPDATE_TARIFF_BY_BUILDING = 'UPDATE_TARIFF_BY_BUILDING'
export const DELETE_TARIFF_BY_BUILDING = 'DELETE_TARIFF_BY_BUILDING'
